export default __webpack_public_path__ + "static/logo-white-b69ced2434a1653dce7e40893718c078.svg";